import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  SimpleGrid,
  VStack,
  useColorModeValue,
  Icon,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { CustomIcon } from "../CustomIcon";
import { SERVICES_DATA } from "../../data/services";
import { getServiceDetailPath } from "../../config/routes";

const MotionBox = motion(Box);

export const ServicesSection = () => {
  const navigate = useNavigate();
  const bgColor = useColorModeValue("gray.50", "dark.200");
  const cardBg = useColorModeValue("white", "whiteAlpha.50");
  const borderColor = useColorModeValue("gray.100", "gray.700");
  const textColor = useColorModeValue("gray.800", "white");
  const descColor = useColorModeValue("gray.600", "gray.400");
  const iconBg = useColorModeValue("brand.100", "icon.bg");
  const iconColor = useColorModeValue("brand.500", "icon.svg");

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <Box id="services" py={20} bg={bgColor}>
      <Container maxW="container.xl">
        <VStack spacing={12}>
          {/* Section Header */}
          <VStack spacing={4} textAlign="center">
            <Heading
              as="h2"
              fontSize={{ base: "xl", md: "2xl", lg: "3xl" }}
              color={textColor}
            >
              خدمات تأمین سرمایه امید
            </Heading>
            <Text
              fontSize={{ base: "md", md: "lg" }}
              color={descColor}
              maxW="600px"
            >
              ما با ارائه خدمات متنوع و تخصصی، همراه شما در مسیر رشد و موفقیت
              مالی هستیم
            </Text>
          </VStack>

          {/* Services Grid */}
          <SimpleGrid
            columns={{ base: 1, md: 2, lg: 4 }}
            spacing={{ base: 6, md: 8 }}
            w="100%"
            as={motion.div}
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
          >
            {SERVICES_DATA.slice(0, 4).map((service) => (
              <MotionBox
                key={service.id}
                variants={itemVariants}
                whileHover={{
                  y: -8,
                  scale: 1.02,
                }}
                transition={{ duration: 0.3 }}
              >
                <Box
                  bg={cardBg}
                  borderRadius="2xl"
                  border="1px solid"
                  borderColor={borderColor}
                  p={6}
                  shadow="sm"
                  _hover={{
                    shadow: "xl",
                  }}
                  transition="all 0.3s"
                  h="100%"
                  cursor="pointer"
                  onClick={() => navigate(getServiceDetailPath(service.id))}
                >
                  <VStack align="start" spacing={4}>
                    {/* Icon */}
                    <Box
                      bg={iconBg}
                      p={3}
                      borderRadius="xl"
                      display="inline-flex"
                    >
                      <CustomIcon
                        icon={service.icon}
                        size={24}
                        color={iconColor}
                      />
                    </Box>

                    {/* Title */}
                    <Heading as="h3" size="md" color={textColor}>
                      {service.title}
                    </Heading>

                    {/* Description */}
                    <Text fontSize="sm" color={descColor} lineHeight="tall">
                      {service.description}
                    </Text>
                  </VStack>
                </Box>
              </MotionBox>
            ))}
          </SimpleGrid>

          <Button
            size="lg"
            colorScheme="brand"
            variant="secondary"
            rightIcon={<Icon verticalAlign="middle" as={FiArrowLeft as any} />}
            onClick={() => navigate("/services")}
          >
            مشاهده همه خدمات
          </Button>
        </VStack>
      </Container>
    </Box>
  );
};
